import { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css/bundle';
import { Url } from './Url';


const Sliders = props => {
	

	const data = props.data
    const tipo = props.tipo


    useEffect(() => {
        
    }, [])

	let slides = [];

	data && data.map((item, index) => (

		slides.push(
			<SwiperSlide className={tipo === 1 && 'h-72' } key={index}>
				<Link
					to={"categoria/"+item.id}
				>
                    { tipo === 1 ? (
                        <img className='object-cover w-full rounded-md' src={Url + item.imagen} alt="img" />
                    ) : (
                        <div className="h-26 bg-white rounded-xl py-10 text-gray-600 border border-gray-200 text-center text-xl hover:bg-slate-50 hover:cursor-pointer" key={index}>
                            <p>{item.descripcion}</p>
                        </div>
                    )}
				</Link>
			</SwiperSlide>
		)
	));
	return (
		<Swiper
			spaceBetween={20}
			slidesPerView={1}
			breakpoints={{
				// when window width is >= 320px
				320: {
					slidesPerView: 2,
					spaceBetween: 5
				},
				// when window width is >= 480px
				480: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				// when window width is >= 640px
				800: {
					slidesPerView: 3,
					spaceBetween: 20
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 20
				}

			}}
			observer={true}
			centeredSlides={false}
			autoplay={{
				delay: 4500,
				disableOnInteraction: true,
			}}

			modules={[Autoplay, Pagination, Navigation]}

			speed={500}
			loop={true}
			touchRatio={1.5}
			effect={"fade"}
			className="mySwiper"
		>
			{slides}
		</Swiper>
	);
}

export default Sliders